import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["c-icon", { 'is-small': _ctx.$props.small }]),
    innerHTML: _ctx.content
  }, null, 10 /* CLASS, PROPS */, _hoisted_1))
}